module.exports = __webpack_public_path__ + "media/BEEP.e7e97c0a.wav";